import Button from '@atoms/Button/Button';
import CheckboxInput from '@atoms/Inputs/CheckboxInput';
import { ITEMS_ABOVE_FOLD } from '@constants';
import ChevronDownIcon from '@svg/chevron-down.svg';
import ChevronUpIcon from '@svg/chevron-up.svg';
import PropTypes from 'prop-types';
import { useState } from 'react';

import styles from './CheckboxGroup.module.scss';

function CheckboxGroup({
  name,
  options,
  onChange,
  foldCount = ITEMS_ABOVE_FOLD,
}) {
  const [showFold, setShowFold] = useState(false);

  const aboveFold = options.slice(0, foldCount);
  const belowFold = options.slice(foldCount);
  const checkedBelowFold = belowFold.filter(
    option => option.checked === true
  )?.length;

  const toggleFold = () => {
    setShowFold(!showFold);
  };

  return (
    <div className={styles.group}>
      {aboveFold.map(({ label, id, checked }) => (
        <CheckboxInput
          key={id}
          checked={checked}
          id={`check-${name}-${id}`}
          value={id.toString()}
          name={name}
          onChange={onChange}
          label={label}
          groupCheckbox
        />
      ))}

      {!!belowFold.length && !showFold && (
        <Button
          extraClasses={styles.foldButton}
          modifierClass="noUnderline"
          onClick={toggleFold}
          label={`<span class="${styles.label}">Bekijk meer</span> 
            ${
              checkedBelowFold
                ? `<span class="${styles.checkboxCounter}">
                  ${checkedBelowFold}
                </span>`
                : ''
            }
          `}
          Icon={ChevronDownIcon}
          noAnimation
          variant="text"
          isRawLabel
        />
      )}

      {!!belowFold.length &&
        showFold &&
        belowFold.map(({ label, id, checked }) => (
          <CheckboxInput
            key={id}
            checked={checked}
            id={`check-${name}-${id}`}
            value={id.toString()}
            name={name}
            onChange={onChange}
            label={label}
            groupCheckbox
          />
        ))}

      {!!belowFold.length && showFold && (
        <Button
          extraClasses={styles.foldButton}
          onClick={toggleFold}
          label="Bekijk minder"
          Icon={ChevronUpIcon}
          noAnimation
          variant="text"
        />
      )}
    </div>
  );
}

CheckboxGroup.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  foldCount: PropTypes.number,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default CheckboxGroup;
